import _ from "lodash"

let initialized = false
let useTemp = false;

let config = {
    HAPPINESS_MIN_IN: 0,
    HAPPINESS_MIN_OUT: 0,
    HAPPINESS_MAX_IN: 0,
    HAPPINESS_MAX_OUT: 0,
    HAPPINESS_CERTAINTY_THRESHOLD: 0,
    NEUTRAL_MIN_IN: 0,
    NEUTRAL_MIN_OUT: 0,
    NEUTRAL_MAX_IN: 0,
    NEUTRAL_MAX_OUT: 0,
    NEUTRAL_CERTAINTY_THRESHOLD: 0,
    EMOTIONAL_MIN_IN: 0,
    EMOTIONAL_MIN_OUT: 0,
    EMOTIONAL_MAX_IN: 0,
    EMOTIONAL_MAX_OUT: 0,
    SADNESS_CERTAINTY_THRESHOLD: 0,
    ANGRY_CERTAINTY_THRESHOLD: 0,
    BASELINE_HAPPINESS_MIN_IN: 0,
    BASELINE_HAPPINESS_MIN_OUT: 0,
    BASELINE_HAPPINESS_MAX_IN: 0,
    BASELINE_HAPPINESS_MAX_OUT: 0,
    BASELINE_HAPPINESS_CERTAINTY_THRESHOLD: 0,
    BASELINE_NEUTRAL_MIN_IN: 0,
    BASELINE_NEUTRAL_MIN_OUT: 0,
    BASELINE_NEUTRAL_MAX_IN: 0,
    BASELINE_NEUTRAL_MAX_OUT: 0,
    BASELINE_NEUTRAL_CERTAINTY_THRESHOLD: 0,
    BASELINE_EMOTIONAL_MIN_IN: 0,
    BASELINE_EMOTIONAL_MIN_OUT: 0,
    BASELINE_EMOTIONAL_MAX_IN: 0,
    BASELINE_EMOTIONAL_MAX_OUT: 0,
    BASELINE_SADNESS_CERTAINTY_THRESHOLD: 0,
    BASELINE_ANGRY_CERTAINTY_THRESHOLD: 0,
    DISGUSTED_CERTAINTY_THRESHOLD: 0,
    BASELINE_DISGUSTED_CERTAINTY_THRESHOLD: 0,
    FEARFUL_CERTAINTY_THRESHOLD: 0,
    BASELINE_FEARFUL_CERTAINTY_THRESHOLD: 0,
    SURPRISED_CERTAINTY_THRESHOLD: 0,
    BASELINE_SURPRISED_CERTAINTY_THRESHOLD: 0,
    ENERGY_CONVERSION_FACTOR_NEUTRAL: 0,
    ENERGY_CONVERSION_FACTOR_HAPPINESS: 0,
    ENERGY_CONVERSION_FACTOR_DISGUSTED: 0,
    ENERGY_CONVERSION_FACTOR_SAD: 0,
    ENERGY_CONVERSION_FACTOR_ANGRY: 0,
    ENERGY_CONVERSION_FACTOR_FEARFUL: 0,
    ENERGY_CONVERSION_FACTOR_SURPRISED: 0,
    VALENCE_CONVERSION_FACTOR_NEUTRAL: 0,
    VALENCE_CONVERSION_FACTOR_HAPPINESS: 0,
    VALENCE_CONVERSION_FACTOR_DISGUSTED: 0,
    VALENCE_CONVERSION_FACTOR_SAD: 0,
    VALENCE_CONVERSION_FACTOR_ANGRY: 0,
    VALENCE_CONVERSION_FACTOR_FEARFUL: 0,
    VALENCE_CONVERSION_FACTOR_SURPRISED: 0,
    BASELINE_ANGRY_MIN_IN: 0,
    BASELINE_ANGRY_MAX_IN: 0,
    BASELINE_ANGRY_MAX_OUT: 0,
    BASELINE_ANGRY_MIN_OUT: 0,
    BASELINE_DISGUSTED_MIN_IN: 0,
    BASELINE_DISGUSTED_MAX_IN: 0,
    BASELINE_DISGUSTED_MAX_OUT: 0,
    BASELINE_DISGUSTED_MIN_OUT: 0,
    BASELINE_SAD_MIN_IN: 0,
    BASELINE_SAD_MIN_OUT: 0,
    BASELINE_SAD_MAX_IN: 0,
    BASELINE_SAD_MAX_OUT: 0,
    BASELINE_FEARFUL_MIN_IN: 0,
    BASELINE_FEARFUL_MIN_OUT: 0,
    BASELINE_FEARFUL_MAX_IN: 0,
    BASELINE_FEARFUL_MAX_OUT: 0,
    BASELINE_SURPRISED_MIN_IN: 0,
    BASELINE_SURPRISED_MIN_OUT: 0,
    BASELINE_SURPRISED_MAX_IN: 0,
    BASELINE_SURPRISED_MAX_OUT: 0,
    SAD_MIN_IN: 0,
    SAD_MIN_OUT: 0,
    SAD_MAX_IN: 0,
    SAD_MAX_OUT: 0,
    ANGRY_MIN_IN: 0,
    ANGRY_MIN_OUT: 0,
    ANGRY_MAX_IN: 0,
    ANGRY_MAX_OUT: 0,
    FEARFUL_MIN_IN: 0,
    FEARFUL_MIN_OUT: 0,
    FEARFUL_MAX_IN: 0,
    FEARFUL_MAX_OUT: 0,
    DISGUSTED_MIN_IN: 0,
    DISGUSTED_MIN_OUT: 0,
    DISGUSTED_MAX_IN: 0,
    DISGUSTED_MAX_OUT: 0,
    SURPRISED_MIN_IN: 0,
    SURPRISED_MIN_OUT: 0,
    SURPRISED_MAX_IN: 0,
    SURPRISED_MAX_OUT: 0,
    STRESS_CONVERSION_FACTOR_ANGRY: 0,
    STRESS_CONVERSION_FACTOR_FEAR: 0,
    STRESS_CONVERSION_FACTOR_NEUTRAL: 0,
    STRESS_CONVERSION_FACTOR_HAPPINESS: 0,
    STRESS_CONVERSION_FACTOR_SAD: 0,
    STRESS_CONVERSION_FACTOR_SURPRISED: 0,
    STRESS_CONVERSION_FACTOR_DISGUSTED: 0,
    WELLBEING_CONVERSION_FACTOR_HAPPINESS: 0,
    WELLBEING_CONVERSION_FACTOR_NEUTRAL: 0,
    WELLBEING_CONVERSION_FACTOR_ANGRY: 0,
    WELLBEING_CONVERSION_FACTOR_FEAR: 0,
    WELLBEING_CONVERSION_FACTOR_SAD: 0,
    WELLBEING_CONVERSION_FACTOR_SURPRISED: 0,
    WELLBEING_CONVERSION_FACTOR_DISGUSTED: 0,
    ENGAGEMENT_CONVERSION_FACTOR_HAPPINESS: 0,
    ENGAGEMENT_CONVERSION_FACTOR_SAD: 0,
    ENGAGEMENT_CONVERSION_FACTOR_SURPRISED: 0,
    ENGAGEMENT_CONVERSION_FACTOR_FEAR: 0,
    ENGAGEMENT_CONVERSION_FACTOR_DISGUSTED: 0,
    ENGAGEMENT_CONVERSION_FACTOR_NEUTRAL: 0,
    ENGAGEMENT_CONVERSION_FACTOR_ANGRY: 0,
    INTEREST_CONVERSION_FACTOR_HAPPINESS: 0,
    INTEREST_CONVERSION_FACTOR_SAD: 0,
    INTEREST_CONVERSION_FACTOR_SURPRISED: 0,
    INTEREST_CONVERSION_FACTOR_FEAR: 0,
    INTEREST_CONVERSION_FACTOR_DISGUSTED: 0,
    INTEREST_CONVERSION_FACTOR_NEUTRAL: 0,
    INTEREST_CONVERSION_FACTOR_ANGRY: 0,
    ENERGY_CONVERSION_FACTOR_HAPPINESS_V2: 0,
    ENERGY_CONVERSION_FACTOR_NEUTRAL_V2: 0,
    VALENCE_CONVERSION_FACTOR_HAPPINESS_V2: 0,
    YAWN_CERTAINTY_THRESHOLD: 0.5,
    YAWN_TIREDNESS_TIME_THRESHOLD: 0.5,
    EYE_CLOSED_CERTAINTY_THRESHOLD: 0.5,
    EYE_CLOSED_ASLEEP_TIME_THRESHOLD: 0.5,
    EYE_BLINKED_CERTAINTY_THRESHOLD: 0.5,
    YAW_ANGLE_ALERT_THRESHOLD: 0.5,
    PITCH_ANGLE_MIN_ALERT_THRESHOLD: 0.5,
    PITCH_ANGLE_MAX_ALERT_THRESHOLD: 0.5,
    YAW_ANGLE_MIN_ALERT_THRESHOLD: 0.5,
    YAW_ANGLE_MAX_ALERT_THRESHOLD: 0.5,
    PITCH_ANGLE_MIN_EMOTION_FILTER_THRESHOLD: 0.5,
    PITCH_ANGLE_MAX_EMOTION_FILTER_THRESHOLD: 0.5,
    YAW_ANGLE_MIN_EMOTION_FILTER_THRESHOLD: 0.5,
    YAW_ANGLE_MAX_EMOTION_FILTER_THRESHOLD: 0.5,
    ROLL_ANGLE_MIN_EMOTION_FILTER_THRESHOLD: 0.5,
    ROLL_ANGLE_MAX_EMOTION_FILTER_THRESHOLD: 0.5,
}
let tempConfig = {
    HAPPINESS_MIN_IN: 0,
    HAPPINESS_MIN_OUT: 0,
    HAPPINESS_MAX_IN: 0,
    HAPPINESS_MAX_OUT: 0,
    HAPPINESS_CERTAINTY_THRESHOLD: 0,
    NEUTRAL_MIN_IN: 0,
    NEUTRAL_MIN_OUT: 0,
    NEUTRAL_MAX_IN: 0,
    NEUTRAL_MAX_OUT: 0,
    NEUTRAL_CERTAINTY_THRESHOLD: 0,
    EMOTIONAL_MIN_IN: 0,
    EMOTIONAL_MIN_OUT: 0,
    EMOTIONAL_MAX_IN: 0,
    EMOTIONAL_MAX_OUT: 0,
    SADNESS_CERTAINTY_THRESHOLD: 0,
    ANGRY_CERTAINTY_THRESHOLD: 0,
    BASELINE_HAPPINESS_MIN_IN: 0,
    BASELINE_HAPPINESS_MIN_OUT: 0,
    BASELINE_HAPPINESS_MAX_IN: 0,
    BASELINE_HAPPINESS_MAX_OUT: 0,
    BASELINE_HAPPINESS_CERTAINTY_THRESHOLD: 0,
    BASELINE_NEUTRAL_MIN_IN: 0,
    BASELINE_NEUTRAL_MIN_OUT: 0,
    BASELINE_NEUTRAL_MAX_IN: 0,
    BASELINE_NEUTRAL_MAX_OUT: 0,
    BASELINE_NEUTRAL_CERTAINTY_THRESHOLD: 0,
    BASELINE_EMOTIONAL_MIN_IN: 0,
    BASELINE_EMOTIONAL_MIN_OUT: 0,
    BASELINE_EMOTIONAL_MAX_IN: 0,
    BASELINE_EMOTIONAL_MAX_OUT: 0,
    BASELINE_SADNESS_CERTAINTY_THRESHOLD: 0,
    BASELINE_ANGRY_CERTAINTY_THRESHOLD: 0,
    DISGUSTED_CERTAINTY_THRESHOLD: 0,
    BASELINE_DISGUSTED_CERTAINTY_THRESHOLD: 0,
    FEARFUL_CERTAINTY_THRESHOLD: 0,
    BASELINE_FEARFUL_CERTAINTY_THRESHOLD: 0,
    SURPRISED_CERTAINTY_THRESHOLD: 0,
    BASELINE_SURPRISED_CERTAINTY_THRESHOLD: 0,
    ENERGY_CONVERSION_FACTOR_NEUTRAL: 0,
    ENERGY_CONVERSION_FACTOR_HAPPINESS: 0,
    ENERGY_CONVERSION_FACTOR_DISGUSTED: 0,
    ENERGY_CONVERSION_FACTOR_SAD: 0,
    ENERGY_CONVERSION_FACTOR_ANGRY: 0,
    ENERGY_CONVERSION_FACTOR_FEARFUL: 0,
    ENERGY_CONVERSION_FACTOR_SURPRISED: 0,
    VALENCE_CONVERSION_FACTOR_NEUTRAL: 0,
    VALENCE_CONVERSION_FACTOR_HAPPINESS: 0,
    VALENCE_CONVERSION_FACTOR_DISGUSTED: 0,
    VALENCE_CONVERSION_FACTOR_SAD: 0,
    VALENCE_CONVERSION_FACTOR_ANGRY: 0,
    VALENCE_CONVERSION_FACTOR_FEARFUL: 0,
    VALENCE_CONVERSION_FACTOR_SURPRISED: 0,
    BASELINE_ANGRY_MIN_IN: 0,
    BASELINE_ANGRY_MAX_IN: 0,
    BASELINE_ANGRY_MAX_OUT: 0,
    BASELINE_ANGRY_MIN_OUT: 0,
    BASELINE_DISGUSTED_MIN_IN: 0,
    BASELINE_DISGUSTED_MAX_IN: 0,
    BASELINE_DISGUSTED_MAX_OUT: 0,
    BASELINE_DISGUSTED_MIN_OUT: 0,
    BASELINE_SAD_MIN_IN: 0,
    BASELINE_SAD_MIN_OUT: 0,
    BASELINE_SAD_MAX_IN: 0,
    BASELINE_SAD_MAX_OUT: 0,
    BASELINE_FEARFUL_MIN_IN: 0,
    BASELINE_FEARFUL_MIN_OUT: 0,
    BASELINE_FEARFUL_MAX_IN: 0,
    BASELINE_FEARFUL_MAX_OUT: 0,
    BASELINE_SURPRISED_MIN_IN: 0,
    BASELINE_SURPRISED_MIN_OUT: 0,
    BASELINE_SURPRISED_MAX_IN: 0,
    BASELINE_SURPRISED_MAX_OUT: 0,
    SAD_MIN_IN: 0,
    SAD_MIN_OUT: 0,
    SAD_MAX_IN: 0,
    SAD_MAX_OUT: 0,
    ANGRY_MIN_IN: 0,
    ANGRY_MIN_OUT: 0,
    ANGRY_MAX_IN: 0,
    ANGRY_MAX_OUT: 0,
    FEARFUL_MIN_IN: 0,
    FEARFUL_MIN_OUT: 0,
    FEARFUL_MAX_IN: 0,
    FEARFUL_MAX_OUT: 0,
    DISGUSTED_MIN_IN: 0,
    DISGUSTED_MIN_OUT: 0,
    DISGUSTED_MAX_IN: 0,
    DISGUSTED_MAX_OUT: 0,
    SURPRISED_MIN_IN: 0,
    SURPRISED_MIN_OUT: 0,
    SURPRISED_MAX_IN: 0,
    SURPRISED_MAX_OUT: 0,
    STRESS_CONVERSION_FACTOR_ANGRY: 0,
    STRESS_CONVERSION_FACTOR_FEAR: 0,
    STRESS_CONVERSION_FACTOR_NEUTRAL: 0,
    STRESS_CONVERSION_FACTOR_HAPPINESS: 0,
    STRESS_CONVERSION_FACTOR_SAD: 0,
    STRESS_CONVERSION_FACTOR_SURPRISED: 0,
    STRESS_CONVERSION_FACTOR_DISGUSTED: 0,
    WELLBEING_CONVERSION_FACTOR_HAPPINESS: 0,
    WELLBEING_CONVERSION_FACTOR_NEUTRAL: 0,
    WELLBEING_CONVERSION_FACTOR_ANGRY: 0,
    WELLBEING_CONVERSION_FACTOR_FEAR: 0,
    WELLBEING_CONVERSION_FACTOR_SAD: 0,
    WELLBEING_CONVERSION_FACTOR_SURPRISED: 0,
    WELLBEING_CONVERSION_FACTOR_DISGUSTED: 0,
    ENGAGEMENT_CONVERSION_FACTOR_HAPPINESS: 0,
    ENGAGEMENT_CONVERSION_FACTOR_SAD: 0,
    ENGAGEMENT_CONVERSION_FACTOR_SURPRISED: 0,
    ENGAGEMENT_CONVERSION_FACTOR_FEAR: 0,
    ENGAGEMENT_CONVERSION_FACTOR_DISGUSTED: 0,
    ENGAGEMENT_CONVERSION_FACTOR_NEUTRAL: 0,
    ENGAGEMENT_CONVERSION_FACTOR_ANGRY: 0,
    INTEREST_CONVERSION_FACTOR_HAPPINESS: 0,
    INTEREST_CONVERSION_FACTOR_SAD: 0,
    INTEREST_CONVERSION_FACTOR_SURPRISED: 0,
    INTEREST_CONVERSION_FACTOR_FEAR: 0,
    INTEREST_CONVERSION_FACTOR_DISGUSTED: 0,
    INTEREST_CONVERSION_FACTOR_NEUTRAL: 0,
    INTEREST_CONVERSION_FACTOR_ANGRY: 0,
    ENERGY_CONVERSION_FACTOR_HAPPINESS_V2: 0,
    ENERGY_CONVERSION_FACTOR_NEUTRAL_V2: 0,
    VALENCE_CONVERSION_FACTOR_HAPPINESS_V2: 0,
};

const initCheck = () => {
    if (!initialized) {
        throw "Error! config is not initialized"
    }
    if (useTemp) {
        return tempConfig;
    } else {
        return config;
    }
}

export const getConfigItem = (key) => {
    if (!initialized) {
        throw new Error('Config not initialized');
    }
    if(!config[key]){
        throw new Error(`Config key ${key} not found`);
    }
    return config[key];
}

export const calcEmotionsAvg = (tracker, baseline = false, duration = null) => {

    let config = initCheck()

    let positiveSamples = {
        emotional: 0,
        happiness: 0,
        neutral: 0,
        angry: 0,
        disgusted: 0,
        surprised: 0,
        sad: 0,
        fearful: 0
    };

    if (!tracker || tracker.length === 0) {
        return positiveSamples;
    }

    let last = _.last(tracker);
    let maxTime = duration || _.get(last, "songDuration");
    if (maxTime === 0) {
        maxTime = 1;
    }
    console.log("maxTime", maxTime)


    let happinessSamples = [];
    let neutralSamples = [];
    let angrySamples = [];
    let disgustedSamples = [];
    let surprisedSamples = [];
    let sadSamples = [];
    let fearfulSamples = [];

    tracker.forEach((item) => {
        const {emotions} = item;

        if (isEmotional(emotions, baseline)) {
            positiveSamples.emotional++;
        }
        if (isEmotionHappy(emotions.happy, baseline)) {
            positiveSamples.happiness++;
        }
        if (isNeutral(emotions.neutral, baseline)) {
            positiveSamples.neutral++;
        }
        if (isAngry(emotions.angry, baseline)) {
            positiveSamples.angry++;
        }
        if (isDisgusted(emotions.disgusted, baseline)) {
            positiveSamples.disgusted++;
        }
        if (isSurprised(emotions.surprised, baseline)) {
            positiveSamples.surprised++;
        }
        if (isSad(emotions.sad, baseline)) {
            positiveSamples.sad++;
        }
        if (isFearful(emotions.fearful, baseline)) {
            positiveSamples.fearful++;
        }

        happinessSamples.push(emotions.happy)
        neutralSamples.push(emotions.neutral)
        angrySamples.push(emotions.angry)
        disgustedSamples.push(emotions.disgusted)
        surprisedSamples.push(emotions.surprised)
        sadSamples.push(emotions.sad)
        fearfulSamples.push(emotions.fearful)
    })

    const emotionalOverTime = positiveSamples.emotional / maxTime;
    const happinessOverTime = positiveSamples.happiness / maxTime;
    const neutralOverTime = positiveSamples.neutral / maxTime;
    const angryOverTime = positiveSamples.angry / maxTime;
    const disgustedOverTime = positiveSamples.disgusted / maxTime;
    const surprisedOverTime = positiveSamples.surprised / maxTime;
    const sadOverTime = positiveSamples.sad / maxTime;
    const fearfulOverTime = positiveSamples.fearful / maxTime;

    const happinessSamplesAvg = happinessSamples.length > 0 ? _.sum(happinessSamples) / happinessSamples.length : 0;
    const neutralSamplesAvg = neutralSamples.length > 0 ? _.sum(neutralSamples) / neutralSamples.length : 0;
    const angrySamplesAvg = angrySamples.length > 0 ? _.sum(angrySamples) / angrySamples.length : 0;
    const disgustedSamplesAvg = disgustedSamples.length > 0 ? _.sum(disgustedSamples) / disgustedSamples.length : 0;
    const surprisedSamplesAvg = surprisedSamples.length > 0 ? _.sum(surprisedSamples) / surprisedSamples.length : 0;
    const sadSamplesAvg = sadSamples.length > 0 ? _.sum(sadSamples) / sadSamples.length : 0;
    const fearfulSamplesAvg = fearfulSamples.length > 0 ? _.sum(fearfulSamples) / fearfulSamples.length : 0;

    const {
        HAPPINESS_MIN_IN,
        HAPPINESS_MIN_OUT,
        HAPPINESS_MAX_IN,
        HAPPINESS_MAX_OUT,
        NEUTRAL_MIN_IN,
        NEUTRAL_MIN_OUT,
        NEUTRAL_MAX_IN,
        NEUTRAL_MAX_OUT,
        EMOTIONAL_MIN_IN,
        EMOTIONAL_MIN_OUT,
        EMOTIONAL_MAX_IN,
        EMOTIONAL_MAX_OUT,
        BASELINE_HAPPINESS_MIN_IN,
        BASELINE_HAPPINESS_MIN_OUT,
        BASELINE_HAPPINESS_MAX_IN,
        BASELINE_HAPPINESS_MAX_OUT,
        BASELINE_NEUTRAL_MIN_IN,
        BASELINE_NEUTRAL_MIN_OUT,
        BASELINE_NEUTRAL_MAX_IN,
        BASELINE_NEUTRAL_MAX_OUT,
        BASELINE_EMOTIONAL_MIN_IN,
        BASELINE_EMOTIONAL_MIN_OUT,
        BASELINE_EMOTIONAL_MAX_IN,
        BASELINE_EMOTIONAL_MAX_OUT,
        BASELINE_ANGRY_MIN_IN,
        BASELINE_ANGRY_MAX_IN,
        BASELINE_ANGRY_MAX_OUT,
        BASELINE_ANGRY_MIN_OUT,
        BASELINE_DISGUSTED_MIN_IN,
        BASELINE_DISGUSTED_MAX_IN,
        BASELINE_DISGUSTED_MAX_OUT,
        BASELINE_DISGUSTED_MIN_OUT,
        BASELINE_SAD_MIN_IN,
        BASELINE_SAD_MIN_OUT,
        BASELINE_SAD_MAX_IN,
        BASELINE_SAD_MAX_OUT,
        BASELINE_FEARFUL_MIN_IN,
        BASELINE_FEARFUL_MIN_OUT,
        BASELINE_FEARFUL_MAX_IN,
        BASELINE_FEARFUL_MAX_OUT,
        BASELINE_SURPRISED_MIN_IN,
        BASELINE_SURPRISED_MIN_OUT,
        BASELINE_SURPRISED_MAX_IN,
        BASELINE_SURPRISED_MAX_OUT,
        SAD_MIN_IN,
        SAD_MIN_OUT,
        SAD_MAX_IN,
        SAD_MAX_OUT,
        ANGRY_MIN_IN,
        ANGRY_MIN_OUT,
        ANGRY_MAX_IN,
        ANGRY_MAX_OUT,
        FEARFUL_MIN_IN,
        FEARFUL_MIN_OUT,
        FEARFUL_MAX_IN,
        FEARFUL_MAX_OUT,
        DISGUSTED_MIN_IN,
        DISGUSTED_MIN_OUT,
        DISGUSTED_MAX_IN,
        DISGUSTED_MAX_OUT,
        SURPRISED_MIN_IN,
        SURPRISED_MIN_OUT,
        SURPRISED_MAX_IN,
        SURPRISED_MAX_OUT,
    } = config;

    if (baseline) {
        return {
            emotional: ((emotionalOverTime - BASELINE_EMOTIONAL_MIN_IN) / (BASELINE_EMOTIONAL_MAX_IN - BASELINE_EMOTIONAL_MIN_IN)) * (BASELINE_EMOTIONAL_MAX_OUT - BASELINE_EMOTIONAL_MIN_OUT) + BASELINE_EMOTIONAL_MIN_OUT,
            happiness: ((happinessOverTime - BASELINE_HAPPINESS_MIN_IN) / (BASELINE_HAPPINESS_MAX_IN - BASELINE_HAPPINESS_MIN_IN)) * (BASELINE_HAPPINESS_MAX_OUT - BASELINE_HAPPINESS_MIN_OUT) + BASELINE_HAPPINESS_MIN_OUT,
            neutral: ((neutralOverTime - BASELINE_NEUTRAL_MIN_IN) / (BASELINE_NEUTRAL_MAX_IN - BASELINE_NEUTRAL_MIN_IN)) * (BASELINE_NEUTRAL_MAX_OUT - BASELINE_NEUTRAL_MIN_OUT) + BASELINE_NEUTRAL_MIN_OUT,
            angry: ((angryOverTime - BASELINE_ANGRY_MIN_IN) / (BASELINE_ANGRY_MAX_IN - BASELINE_ANGRY_MIN_IN)) * (BASELINE_ANGRY_MAX_OUT - BASELINE_ANGRY_MIN_OUT) + BASELINE_ANGRY_MIN_OUT,
            disgusted: ((disgustedOverTime - BASELINE_DISGUSTED_MIN_IN) / (BASELINE_DISGUSTED_MAX_IN - BASELINE_DISGUSTED_MIN_IN)) * (BASELINE_DISGUSTED_MAX_OUT - BASELINE_DISGUSTED_MIN_OUT) + BASELINE_DISGUSTED_MIN_OUT,
            surprised: ((surprisedOverTime - BASELINE_SURPRISED_MIN_IN) / (BASELINE_SURPRISED_MAX_IN - BASELINE_SURPRISED_MIN_IN)) * (BASELINE_SURPRISED_MAX_OUT - BASELINE_SURPRISED_MIN_OUT) + BASELINE_SURPRISED_MIN_OUT,
            sad: ((sadOverTime - BASELINE_SAD_MIN_IN) / (BASELINE_SAD_MAX_IN - BASELINE_SAD_MIN_IN)) * (BASELINE_SAD_MAX_OUT - BASELINE_SAD_MIN_OUT) + BASELINE_SAD_MIN_OUT,
            fearful: ((fearfulOverTime - BASELINE_FEARFUL_MIN_IN) / (BASELINE_FEARFUL_MAX_IN - BASELINE_FEARFUL_MIN_IN)) * (BASELINE_FEARFUL_MAX_OUT - BASELINE_FEARFUL_MIN_OUT) + BASELINE_FEARFUL_MIN_OUT,
            happinessSamplesAvg,
            neutralSamplesAvg,
            angrySamplesAvg,
            disgustedSamplesAvg,
            surprisedSamplesAvg,
            sadSamplesAvg,
            fearfulSamplesAvg
        }
    }

    return {
        emotional: (((emotionalOverTime - EMOTIONAL_MIN_IN) / (EMOTIONAL_MAX_IN - EMOTIONAL_MIN_IN)) * (EMOTIONAL_MAX_OUT - EMOTIONAL_MIN_OUT) + EMOTIONAL_MIN_OUT) || 0,
        happiness: (((happinessOverTime - HAPPINESS_MIN_IN) / (HAPPINESS_MAX_IN - HAPPINESS_MIN_IN)) * (HAPPINESS_MAX_OUT - HAPPINESS_MIN_OUT) + HAPPINESS_MIN_OUT) || 0,
        neutral: (((neutralOverTime - NEUTRAL_MIN_IN) / (NEUTRAL_MAX_IN - NEUTRAL_MIN_IN)) * (NEUTRAL_MAX_OUT - NEUTRAL_MIN_OUT) + NEUTRAL_MIN_OUT) || 0,
        angry: ((angryOverTime - ANGRY_MIN_IN) / (ANGRY_MAX_IN - ANGRY_MIN_IN)) * (ANGRY_MAX_OUT - ANGRY_MIN_OUT) + ANGRY_MIN_OUT || 0,
        disgusted: ((disgustedOverTime - DISGUSTED_MIN_IN) / (DISGUSTED_MAX_IN - DISGUSTED_MIN_IN)) * (DISGUSTED_MAX_OUT - DISGUSTED_MIN_OUT) + DISGUSTED_MIN_OUT || 0,
        surprised: ((surprisedOverTime - SURPRISED_MIN_IN) / (SURPRISED_MAX_IN - SURPRISED_MIN_IN)) * (SURPRISED_MAX_OUT - SURPRISED_MIN_OUT) + SURPRISED_MIN_OUT || 0,
        sad: ((sadOverTime - SAD_MIN_IN) / (SAD_MAX_IN - SAD_MIN_IN)) * (SAD_MAX_OUT - SAD_MIN_OUT) + SAD_MIN_OUT || 0,
        fearful: ((fearfulOverTime - FEARFUL_MIN_IN) / (FEARFUL_MAX_IN - FEARFUL_MIN_IN)) * (FEARFUL_MAX_OUT - FEARFUL_MIN_OUT) + FEARFUL_MIN_OUT || 0,
        happinessSamplesAvg,
        neutralSamplesAvg,
        angrySamplesAvg,
        disgustedSamplesAvg,
        surprisedSamplesAvg,
        sadSamplesAvg,
        fearfulSamplesAvg
    }
}

export const isEmotionHappy = (emotion, baseline = false) => {

    let config = initCheck()

    if (baseline) {
        return emotion >= config.BASELINE_HAPPINESS_CERTAINTY_THRESHOLD && emotion <= 1;
    }
    return emotion >= config.HAPPINESS_CERTAINTY_THRESHOLD && emotion <= 1;
}

export const isSad = (emotion, baseline = false) => {

    let config = initCheck()
    if (baseline) {
        return emotion >= config.BASELINE_SADNESS_CERTAINTY_THRESHOLD && emotion <= 1;
    }
    return emotion >= config.SADNESS_CERTAINTY_THRESHOLD && emotion <= 1;
}

export const isAngry = (emotion, baseline = false) => {

    let config = initCheck()
    if (baseline) {
        return emotion >= config.BASELINE_ANGRY_CERTAINTY_THRESHOLD && emotion <= 1;
    }
    return emotion >= config.ANGRY_CERTAINTY_THRESHOLD && emotion <= 1;
}

export const isDisgusted = (emotion, baseline = false) => {

    let config = initCheck()
    if (baseline) {
        return emotion >= config.BASELINE_DISGUSTED_CERTAINTY_THRESHOLD && emotion <= 1;
    }
    return emotion >= config.DISGUSTED_CERTAINTY_THRESHOLD && emotion <= 1;
}

export const isSurprised = (emotion, baseline = false) => {

    let config = initCheck()
    if (baseline) {
        return emotion >= config.BASELINE_SURPRISED_CERTAINTY_THRESHOLD && emotion <= 1;
    }
    return emotion >= config.SURPRISED_CERTAINTY_THRESHOLD && emotion <= 1;
}

export const isFearful = (emotion, baseline = false) => {

    let config = initCheck()
    if (baseline) {
        return emotion >= config.BASELINE_FEARFUL_CERTAINTY_THRESHOLD && emotion <= 1;
    }
    return emotion >= config.FEARFUL_CERTAINTY_THRESHOLD && emotion <= 1;
}

export const isNeutral = (emotion, baseline = false) => {

    let config = initCheck()
    if (baseline) {
        return emotion >= config.BASELINE_NEUTRAL_CERTAINTY_THRESHOLD && emotion <= 1;
    }
    return emotion >= config.NEUTRAL_CERTAINTY_THRESHOLD && emotion <= 1;
}

export const isEmotional = (emotions, baseline = false) => {

    return isAngry(emotions.angry, baseline)
        || isSad(emotions.sad, baseline)
        || isDisgusted(emotions.disgusted, baseline)
        || isFearful(emotions.fearful, baseline)
        || isSurprised(emotions.surprised, baseline)
}


/**
 * convert emotions tracker to valance & energy
 * @param tracker - array
 * @returns {{valence: number, energy: number}}
 */
export function convertEmotions(tracker, baseline = false, duration = null) {
    let config = initCheck()
    const avg = calcEmotionsAvg(tracker, baseline, duration)
    const valence = calcValence(avg.happiness, avg.emotional)
    const energy = calcEnergy(avg.happiness, avg.neutral)
    console.log("convertEmotions", {valence, energy, avg})
    return {valence, energy, avg}
}

export function convertCheckupEmotions(tracker, baseline = false, duration = null) {
    let config = initCheck()
    const avg = calcEmotionsAvg(tracker, baseline, duration)

    const samplesAvg = {
        happiness: avg.happinessSamplesAvg,
        neutral: avg.neutralSamplesAvg,
        angry: avg.angrySamplesAvg,
        disgusted: avg.disgustedSamplesAvg,
        surprised: avg.surprisedSamplesAvg,
        sad: avg.sadSamplesAvg,
        fearful: avg.fearfulSamplesAvg
    }

    const valence = calcValenceTracker(samplesAvg)
    const energy = calcEnergyTracker(samplesAvg)
    const stress = calcStress(samplesAvg)
    const wellbeing = calcWellbeing(samplesAvg)
    const engagement = calcEngagement(samplesAvg)
    const interest = calcInterest(samplesAvg)

    console.log("convertEmotions", {valence, energy, stress, wellbeing, engagement, interest, avg})
    return {valence, energy, avg, stress, wellbeing, engagement, interest}
}

export const calcValenceTracker = ({happiness, neutral, angry, disgusted, surprised, sad, fearful}) => {
    let config = initCheck()
    let valence = 0.5 + (
        (config.VALENCE_CONVERSION_FACTOR_HAPPINESS_V2 * happiness) +
        (config.VALENCE_CONVERSION_FACTOR_SAD * sad) +
        (config.VALENCE_CONVERSION_FACTOR_SURPRISED * surprised) +
        (config.VALENCE_CONVERSION_FACTOR_FEARFUL * fearful) +
        (config.VALENCE_CONVERSION_FACTOR_DISGUSTED * disgusted) +
        (config.VALENCE_CONVERSION_FACTOR_NEUTRAL * neutral) +
        (config.VALENCE_CONVERSION_FACTOR_ANGRY * angry)
    );
    return normalizeValue(valence)
}

export const calcValence = (happiness, emotional) => {
    let config = initCheck()
    return 0.5 + ((config.VALENCE_CONVERSION_FACTOR_HAPPINESS * happiness) - (0.5 * emotional))
}

export const calcEnergyTracker = ({happiness, neutral, angry, disgusted, surprised, sad, fearful}) => {
    let config = initCheck()
    let energy = 0.5 + (
        (config.ENERGY_CONVERSION_FACTOR_HAPPINESS_V2 * happiness) +
        (config.ENERGY_CONVERSION_FACTOR_SAD * sad) +
        (config.ENERGY_CONVERSION_FACTOR_SURPRISED * surprised) +
        (config.ENERGY_CONVERSION_FACTOR_FEARFUL * fearful) +
        (config.ENERGY_CONVERSION_FACTOR_DISGUSTED * disgusted) +
        (config.ENERGY_CONVERSION_FACTOR_NEUTRAL_V2 * neutral) +
        (config.ENERGY_CONVERSION_FACTOR_ANGRY * angry)
    );
    return normalizeValue(energy)
}

export const calcEnergy = (happiness, neutral) => {
    let config = initCheck()
    return 0.5 + ((config.ENERGY_CONVERSION_FACTOR_HAPPINESS * happiness) - (config.ENERGY_CONVERSION_FACTOR_NEUTRAL * neutral))
}

export const calcStress = ({happiness, neutral, angry, disgusted, surprised, sad, fearful}) => {
    let config = initCheck()
    let stress = (config.STRESS_CONVERSION_FACTOR_HAPPINESS * happiness) +
        (config.STRESS_CONVERSION_FACTOR_SAD * sad) +
        (config.STRESS_CONVERSION_FACTOR_SURPRISED * surprised) +
        (config.STRESS_CONVERSION_FACTOR_FEAR * fearful) +
        (config.STRESS_CONVERSION_FACTOR_DISGUSTED * disgusted) +
        (config.STRESS_CONVERSION_FACTOR_NEUTRAL * neutral) +
        (config.STRESS_CONVERSION_FACTOR_ANGRY * angry);
    return normalizeValue(stress)
}

export const calcWellbeing = ({happiness, neutral, angry, disgusted, surprised, sad, fearful}) => {
    let config = initCheck()
    let wellbeing = (config.WELLBEING_CONVERSION_FACTOR_HAPPINESS * happiness) +
        (config.WELLBEING_CONVERSION_FACTOR_SAD * sad) +
        (config.WELLBEING_CONVERSION_FACTOR_SURPRISED * surprised) +
        (config.WELLBEING_CONVERSION_FACTOR_FEAR * fearful) +
        (config.WELLBEING_CONVERSION_FACTOR_DISGUSTED * disgusted) +
        (config.WELLBEING_CONVERSION_FACTOR_NEUTRAL * neutral) +
        (config.WELLBEING_CONVERSION_FACTOR_ANGRY * angry);
    return normalizeValue(wellbeing)
}

export const calcInterest = ({happiness, neutral, angry, disgusted, surprised, sad, fearful}) => {
    let config = initCheck()
    let interest = 0.5 + (config.INTEREST_CONVERSION_FACTOR_HAPPINESS * happiness) +
        (config.INTEREST_CONVERSION_FACTOR_SAD * sad) +
        (config.INTEREST_CONVERSION_FACTOR_SURPRISED * surprised) +
        (config.INTEREST_CONVERSION_FACTOR_FEAR * fearful) +
        (config.INTEREST_CONVERSION_FACTOR_DISGUSTED * disgusted) +
        (config.INTEREST_CONVERSION_FACTOR_NEUTRAL * neutral) +
        (config.INTEREST_CONVERSION_FACTOR_ANGRY * angry);
    return normalizeValue(interest)
}

export const calcEngagement = ({happiness, neutral, angry, disgusted, surprised, sad, fearful}) => {
    let config = initCheck()
    let engagement = (config.ENGAGEMENT_CONVERSION_FACTOR_HAPPINESS * happiness) +
        (config.ENGAGEMENT_CONVERSION_FACTOR_SAD * sad) +
        (config.ENGAGEMENT_CONVERSION_FACTOR_SURPRISED * surprised) +
        (config.ENGAGEMENT_CONVERSION_FACTOR_FEAR * fearful) +
        (config.ENGAGEMENT_CONVERSION_FACTOR_DISGUSTED * disgusted) +
        (config.ENGAGEMENT_CONVERSION_FACTOR_NEUTRAL * neutral) +
        (config.ENGAGEMENT_CONVERSION_FACTOR_ANGRY * angry);
    return normalizeValue(engagement)
}


const normalizeValue = (value) => {
    if (!value) {
        return 0;
    } else if (value > 1) {
        return 1;
    } else if (value < 0) {
        return 0;
    }
    return value;
}

export const initConfig = ({
                               HAPPINESS_MIN_IN,
                               HAPPINESS_MIN_OUT,
                               HAPPINESS_MAX_IN,
                               HAPPINESS_MAX_OUT,
                               HAPPINESS_CERTAINTY_THRESHOLD,
                               NEUTRAL_MIN_IN,
                               NEUTRAL_MIN_OUT,
                               NEUTRAL_MAX_IN,
                               NEUTRAL_MAX_OUT,
                               NEUTRAL_CERTAINTY_THRESHOLD,
                               EMOTIONAL_MIN_IN,
                               EMOTIONAL_MIN_OUT,
                               EMOTIONAL_MAX_IN,
                               EMOTIONAL_MAX_OUT,
                               SADNESS_CERTAINTY_THRESHOLD,
                               ANGRY_CERTAINTY_THRESHOLD,
                               BASELINE_HAPPINESS_MIN_IN,
                               BASELINE_HAPPINESS_MIN_OUT,
                               BASELINE_HAPPINESS_MAX_IN,
                               BASELINE_HAPPINESS_MAX_OUT,
                               BASELINE_HAPPINESS_CERTAINTY_THRESHOLD,
                               BASELINE_NEUTRAL_MIN_IN,
                               BASELINE_NEUTRAL_MIN_OUT,
                               BASELINE_NEUTRAL_MAX_IN,
                               BASELINE_NEUTRAL_MAX_OUT,
                               BASELINE_NEUTRAL_CERTAINTY_THRESHOLD,
                               BASELINE_EMOTIONAL_MIN_IN,
                               BASELINE_EMOTIONAL_MIN_OUT,
                               BASELINE_EMOTIONAL_MAX_IN,
                               BASELINE_EMOTIONAL_MAX_OUT,
                               BASELINE_SADNESS_CERTAINTY_THRESHOLD,
                               BASELINE_ANGRY_CERTAINTY_THRESHOLD,
                               DISGUSTED_CERTAINTY_THRESHOLD,
                               BASELINE_DISGUSTED_CERTAINTY_THRESHOLD,
                               FEARFUL_CERTAINTY_THRESHOLD,
                               BASELINE_FEARFUL_CERTAINTY_THRESHOLD,
                               SURPRISED_CERTAINTY_THRESHOLD,
                               BASELINE_SURPRISED_CERTAINTY_THRESHOLD,
                               ENERGY_CONVERSION_FACTOR_NEUTRAL,
                               ENERGY_CONVERSION_FACTOR_HAPPINESS,
                               ENERGY_CONVERSION_FACTOR_DISGUSTED,
                               ENERGY_CONVERSION_FACTOR_SAD,
                               ENERGY_CONVERSION_FACTOR_ANGRY,
                               ENERGY_CONVERSION_FACTOR_FEARFUL,
                               ENERGY_CONVERSION_FACTOR_SURPRISED,
                               VALENCE_CONVERSION_FACTOR_NEUTRAL,
                               VALENCE_CONVERSION_FACTOR_HAPPINESS,
                               VALENCE_CONVERSION_FACTOR_DISGUSTED,
                               VALENCE_CONVERSION_FACTOR_SAD,
                               VALENCE_CONVERSION_FACTOR_ANGRY,
                               VALENCE_CONVERSION_FACTOR_FEARFUL,
                               VALENCE_CONVERSION_FACTOR_SURPRISED,
                               BASELINE_ANGRY_MIN_IN,
                               BASELINE_ANGRY_MAX_IN,
                               BASELINE_ANGRY_MAX_OUT,
                               BASELINE_ANGRY_MIN_OUT,
                               BASELINE_DISGUSTED_MIN_IN,
                               BASELINE_DISGUSTED_MAX_IN,
                               BASELINE_DISGUSTED_MAX_OUT,
                               BASELINE_DISGUSTED_MIN_OUT,
                               BASELINE_SAD_MIN_IN,
                               BASELINE_SAD_MIN_OUT,
                               BASELINE_SAD_MAX_IN,
                               BASELINE_SAD_MAX_OUT,
                               BASELINE_FEARFUL_MIN_IN,
                               BASELINE_FEARFUL_MIN_OUT,
                               BASELINE_FEARFUL_MAX_IN,
                               BASELINE_FEARFUL_MAX_OUT,
                               BASELINE_SURPRISED_MIN_IN,
                               BASELINE_SURPRISED_MIN_OUT,
                               BASELINE_SURPRISED_MAX_IN,
                               BASELINE_SURPRISED_MAX_OUT,
                               SAD_MIN_IN,
                               SAD_MIN_OUT,
                               SAD_MAX_IN,
                               SAD_MAX_OUT,
                               ANGRY_MIN_IN,
                               ANGRY_MIN_OUT,
                               ANGRY_MAX_IN,
                               ANGRY_MAX_OUT,
                               FEARFUL_MIN_IN,
                               FEARFUL_MIN_OUT,
                               FEARFUL_MAX_IN,
                               FEARFUL_MAX_OUT,
                               DISGUSTED_MIN_IN,
                               DISGUSTED_MIN_OUT,
                               DISGUSTED_MAX_IN,
                               DISGUSTED_MAX_OUT,
                               SURPRISED_MIN_IN,
                               SURPRISED_MIN_OUT,
                               SURPRISED_MAX_IN,
                               SURPRISED_MAX_OUT,
                               STRESS_CONVERSION_FACTOR_ANGRY,
                               STRESS_CONVERSION_FACTOR_FEAR,
                               STRESS_CONVERSION_FACTOR_NEUTRAL,
                               STRESS_CONVERSION_FACTOR_HAPPINESS,
                               STRESS_CONVERSION_FACTOR_SAD,
                               STRESS_CONVERSION_FACTOR_SURPRISED,
                               STRESS_CONVERSION_FACTOR_DISGUSTED,
                               WELLBEING_CONVERSION_FACTOR_HAPPINESS,
                               WELLBEING_CONVERSION_FACTOR_NEUTRAL,
                               WELLBEING_CONVERSION_FACTOR_ANGRY,
                               WELLBEING_CONVERSION_FACTOR_FEAR,
                               WELLBEING_CONVERSION_FACTOR_SAD,
                               WELLBEING_CONVERSION_FACTOR_SURPRISED,
                               WELLBEING_CONVERSION_FACTOR_DISGUSTED,
                               ENGAGEMENT_CONVERSION_FACTOR_HAPPINESS,
                               ENGAGEMENT_CONVERSION_FACTOR_SAD,
                               ENGAGEMENT_CONVERSION_FACTOR_SURPRISED,
                               ENGAGEMENT_CONVERSION_FACTOR_FEAR,
                               ENGAGEMENT_CONVERSION_FACTOR_DISGUSTED,
                               ENGAGEMENT_CONVERSION_FACTOR_NEUTRAL,
                               ENGAGEMENT_CONVERSION_FACTOR_ANGRY,
                               INTEREST_CONVERSION_FACTOR_HAPPINESS,
                               INTEREST_CONVERSION_FACTOR_SAD,
                               INTEREST_CONVERSION_FACTOR_SURPRISED,
                               INTEREST_CONVERSION_FACTOR_FEAR,
                               INTEREST_CONVERSION_FACTOR_DISGUSTED,
                               INTEREST_CONVERSION_FACTOR_NEUTRAL,
                               INTEREST_CONVERSION_FACTOR_ANGRY,
                               ENERGY_CONVERSION_FACTOR_HAPPINESS_V2,
                               ENERGY_CONVERSION_FACTOR_NEUTRAL_V2,
                               VALENCE_CONVERSION_FACTOR_HAPPINESS_V2,
                               YAWN_CERTAINTY_THRESHOLD,
                               YAWN_TIREDNESS_TIME_THRESHOLD,
                               EYE_CLOSED_CERTAINTY_THRESHOLD,
                               EYE_CLOSED_ASLEEP_TIME_THRESHOLD,
                               EYE_BLINKED_CERTAINTY_THRESHOLD,
                               YAW_ANGLE_ALERT_THRESHOLD,
                               PITCH_ANGLE_MIN_ALERT_THRESHOLD,
                               PITCH_ANGLE_MAX_ALERT_THRESHOLD,
                               YAW_ANGLE_MIN_ALERT_THRESHOLD,
                               YAW_ANGLE_MAX_ALERT_THRESHOLD,
                               PITCH_ANGLE_MIN_EMOTION_FILTER_THRESHOLD,
                               PITCH_ANGLE_MAX_EMOTION_FILTER_THRESHOLD,
                               YAW_ANGLE_MIN_EMOTION_FILTER_THRESHOLD,
                               YAW_ANGLE_MAX_EMOTION_FILTER_THRESHOLD,
                               ROLL_ANGLE_MIN_EMOTION_FILTER_THRESHOLD,
                               ROLL_ANGLE_MAX_EMOTION_FILTER_THRESHOLD,
                               FILTER_BOX_SIZE,
                               HAND_POINTS_ON_FACE_THRESHOLD
                           }) => {
    config.HAPPINESS_MIN_IN = HAPPINESS_MIN_IN;
    config.HAPPINESS_MIN_OUT = HAPPINESS_MIN_OUT;
    config.HAPPINESS_MAX_IN = HAPPINESS_MAX_IN;
    config.HAPPINESS_MAX_OUT = HAPPINESS_MAX_OUT;
    config.HAPPINESS_CERTAINTY_THRESHOLD = HAPPINESS_CERTAINTY_THRESHOLD;
    config.NEUTRAL_MIN_IN = NEUTRAL_MIN_IN;
    config.NEUTRAL_MIN_OUT = NEUTRAL_MIN_OUT;
    config.NEUTRAL_MAX_IN = NEUTRAL_MAX_IN;
    config.NEUTRAL_MAX_OUT = NEUTRAL_MAX_OUT;
    config.NEUTRAL_CERTAINTY_THRESHOLD = NEUTRAL_CERTAINTY_THRESHOLD;
    config.EMOTIONAL_MIN_IN = EMOTIONAL_MIN_IN;
    config.EMOTIONAL_MIN_OUT = EMOTIONAL_MIN_OUT;
    config.EMOTIONAL_MAX_IN = EMOTIONAL_MAX_IN;
    config.EMOTIONAL_MAX_OUT = EMOTIONAL_MAX_OUT;
    config.SADNESS_CERTAINTY_THRESHOLD = SADNESS_CERTAINTY_THRESHOLD;
    config.ANGRY_CERTAINTY_THRESHOLD = ANGRY_CERTAINTY_THRESHOLD;
    config.BASELINE_HAPPINESS_MIN_IN = BASELINE_HAPPINESS_MIN_IN;
    config.BASELINE_HAPPINESS_MIN_OUT = BASELINE_HAPPINESS_MIN_OUT;
    config.BASELINE_HAPPINESS_MAX_IN = BASELINE_HAPPINESS_MAX_IN;
    config.BASELINE_HAPPINESS_MAX_OUT = BASELINE_HAPPINESS_MAX_OUT;
    config.BASELINE_HAPPINESS_CERTAINTY_THRESHOLD = BASELINE_HAPPINESS_CERTAINTY_THRESHOLD;
    config.BASELINE_NEUTRAL_MIN_IN = BASELINE_NEUTRAL_MIN_IN;
    config.BASELINE_NEUTRAL_MIN_OUT = BASELINE_NEUTRAL_MIN_OUT;
    config.BASELINE_NEUTRAL_MAX_IN = BASELINE_NEUTRAL_MAX_IN;
    config.BASELINE_NEUTRAL_MAX_OUT = BASELINE_NEUTRAL_MAX_OUT;
    config.BASELINE_NEUTRAL_CERTAINTY_THRESHOLD = BASELINE_NEUTRAL_CERTAINTY_THRESHOLD;
    config.BASELINE_EMOTIONAL_MIN_IN = BASELINE_EMOTIONAL_MIN_IN;
    config.BASELINE_EMOTIONAL_MIN_OUT = BASELINE_EMOTIONAL_MIN_OUT;
    config.BASELINE_EMOTIONAL_MAX_IN = BASELINE_EMOTIONAL_MAX_IN;
    config.BASELINE_EMOTIONAL_MAX_OUT = BASELINE_EMOTIONAL_MAX_OUT;
    config.BASELINE_SADNESS_CERTAINTY_THRESHOLD = BASELINE_SADNESS_CERTAINTY_THRESHOLD;
    config.BASELINE_ANGRY_CERTAINTY_THRESHOLD = BASELINE_ANGRY_CERTAINTY_THRESHOLD;
    config.DISGUSTED_CERTAINTY_THRESHOLD = DISGUSTED_CERTAINTY_THRESHOLD;
    config.BASELINE_DISGUSTED_CERTAINTY_THRESHOLD = BASELINE_DISGUSTED_CERTAINTY_THRESHOLD;
    config.FEARFUL_CERTAINTY_THRESHOLD = FEARFUL_CERTAINTY_THRESHOLD;
    config.BASELINE_FEARFUL_CERTAINTY_THRESHOLD = BASELINE_FEARFUL_CERTAINTY_THRESHOLD;
    config.SURPRISED_CERTAINTY_THRESHOLD = SURPRISED_CERTAINTY_THRESHOLD;
    config.BASELINE_SURPRISED_CERTAINTY_THRESHOLD = BASELINE_SURPRISED_CERTAINTY_THRESHOLD;
    config.ENERGY_CONVERSION_FACTOR_NEUTRAL = ENERGY_CONVERSION_FACTOR_NEUTRAL;
    config.ENERGY_CONVERSION_FACTOR_HAPPINESS = ENERGY_CONVERSION_FACTOR_HAPPINESS;
    config.ENERGY_CONVERSION_FACTOR_DISGUSTED = ENERGY_CONVERSION_FACTOR_DISGUSTED;
    config.ENERGY_CONVERSION_FACTOR_SAD = ENERGY_CONVERSION_FACTOR_SAD;
    config.ENERGY_CONVERSION_FACTOR_ANGRY = ENERGY_CONVERSION_FACTOR_ANGRY;
    config.ENERGY_CONVERSION_FACTOR_FEARFUL = ENERGY_CONVERSION_FACTOR_FEARFUL;
    config.ENERGY_CONVERSION_FACTOR_SURPRISED = ENERGY_CONVERSION_FACTOR_SURPRISED;
    config.VALENCE_CONVERSION_FACTOR_NEUTRAL = VALENCE_CONVERSION_FACTOR_NEUTRAL;
    config.VALENCE_CONVERSION_FACTOR_HAPPINESS = VALENCE_CONVERSION_FACTOR_HAPPINESS;
    config.VALENCE_CONVERSION_FACTOR_DISGUSTED = VALENCE_CONVERSION_FACTOR_DISGUSTED;
    config.VALENCE_CONVERSION_FACTOR_SAD = VALENCE_CONVERSION_FACTOR_SAD;
    config.VALENCE_CONVERSION_FACTOR_ANGRY = VALENCE_CONVERSION_FACTOR_ANGRY;
    config.VALENCE_CONVERSION_FACTOR_FEARFUL = VALENCE_CONVERSION_FACTOR_FEARFUL;
    config.VALENCE_CONVERSION_FACTOR_SURPRISED = VALENCE_CONVERSION_FACTOR_SURPRISED;
    config.BASELINE_ANGRY_MIN_IN = BASELINE_ANGRY_MIN_IN;
    config.BASELINE_ANGRY_MAX_IN = BASELINE_ANGRY_MAX_IN;
    config.BASELINE_ANGRY_MAX_OUT = BASELINE_ANGRY_MAX_OUT;
    config.BASELINE_ANGRY_MIN_OUT = BASELINE_ANGRY_MIN_OUT;
    config.BASELINE_DISGUSTED_MIN_IN = BASELINE_DISGUSTED_MIN_IN;
    config.BASELINE_DISGUSTED_MAX_IN = BASELINE_DISGUSTED_MAX_IN;
    config.BASELINE_DISGUSTED_MAX_OUT = BASELINE_DISGUSTED_MAX_OUT;
    config.BASELINE_DISGUSTED_MIN_OUT = BASELINE_DISGUSTED_MIN_OUT;
    config.BASELINE_SAD_MIN_IN = BASELINE_SAD_MIN_IN;
    config.BASELINE_SAD_MIN_OUT = BASELINE_SAD_MIN_OUT;
    config.BASELINE_SAD_MAX_IN = BASELINE_SAD_MAX_IN;
    config.BASELINE_SAD_MAX_OUT = BASELINE_SAD_MAX_OUT;
    config.BASELINE_FEARFUL_MIN_IN = BASELINE_FEARFUL_MIN_IN;
    config.BASELINE_FEARFUL_MIN_OUT = BASELINE_FEARFUL_MIN_OUT;
    config.BASELINE_FEARFUL_MAX_IN = BASELINE_FEARFUL_MAX_IN;
    config.BASELINE_FEARFUL_MAX_OUT = BASELINE_FEARFUL_MAX_OUT;
    config.BASELINE_SURPRISED_MIN_IN = BASELINE_SURPRISED_MIN_IN;
    config.BASELINE_SURPRISED_MIN_OUT = BASELINE_SURPRISED_MIN_OUT;
    config.BASELINE_SURPRISED_MAX_IN = BASELINE_SURPRISED_MAX_IN;
    config.BASELINE_SURPRISED_MAX_OUT = BASELINE_SURPRISED_MAX_OUT;
    config.SAD_MIN_IN = SAD_MIN_IN;
    config.SAD_MIN_OUT = SAD_MIN_OUT;
    config.SAD_MAX_IN = SAD_MAX_IN;
    config.SAD_MAX_OUT = SAD_MAX_OUT;
    config.ANGRY_MIN_IN = ANGRY_MIN_IN;
    config.ANGRY_MIN_OUT = ANGRY_MIN_OUT;
    config.ANGRY_MAX_IN = ANGRY_MAX_IN;
    config.ANGRY_MAX_OUT = ANGRY_MAX_OUT;
    config.FEARFUL_MIN_IN = FEARFUL_MIN_IN;
    config.FEARFUL_MIN_OUT = FEARFUL_MIN_OUT;
    config.FEARFUL_MAX_IN = FEARFUL_MAX_IN;
    config.FEARFUL_MAX_OUT = FEARFUL_MAX_OUT;
    config.DISGUSTED_MIN_IN = DISGUSTED_MIN_IN;
    config.DISGUSTED_MIN_OUT = DISGUSTED_MIN_OUT;
    config.DISGUSTED_MAX_IN = DISGUSTED_MAX_IN;
    config.DISGUSTED_MAX_OUT = DISGUSTED_MAX_OUT;
    config.SURPRISED_MIN_IN = SURPRISED_MIN_IN;
    config.SURPRISED_MIN_OUT = SURPRISED_MIN_OUT;
    config.SURPRISED_MAX_IN = SURPRISED_MAX_IN;
    config.SURPRISED_MAX_OUT = SURPRISED_MAX_OUT;
    config.STRESS_CONVERSION_FACTOR_ANGRY = STRESS_CONVERSION_FACTOR_ANGRY;
    config.STRESS_CONVERSION_FACTOR_FEAR = STRESS_CONVERSION_FACTOR_FEAR;
    config.STRESS_CONVERSION_FACTOR_NEUTRAL = STRESS_CONVERSION_FACTOR_NEUTRAL;
    config.STRESS_CONVERSION_FACTOR_HAPPINESS = STRESS_CONVERSION_FACTOR_HAPPINESS;
    config.STRESS_CONVERSION_FACTOR_SAD = STRESS_CONVERSION_FACTOR_SAD;
    config.STRESS_CONVERSION_FACTOR_SURPRISED = STRESS_CONVERSION_FACTOR_SURPRISED;
    config.STRESS_CONVERSION_FACTOR_DISGUSTED = STRESS_CONVERSION_FACTOR_DISGUSTED;
    config.WELLBEING_CONVERSION_FACTOR_HAPPINESS = WELLBEING_CONVERSION_FACTOR_HAPPINESS;
    config.WELLBEING_CONVERSION_FACTOR_NEUTRAL = WELLBEING_CONVERSION_FACTOR_NEUTRAL;
    config.WELLBEING_CONVERSION_FACTOR_ANGRY = WELLBEING_CONVERSION_FACTOR_ANGRY;
    config.WELLBEING_CONVERSION_FACTOR_FEAR = WELLBEING_CONVERSION_FACTOR_FEAR;
    config.WELLBEING_CONVERSION_FACTOR_SAD = WELLBEING_CONVERSION_FACTOR_SAD;
    config.WELLBEING_CONVERSION_FACTOR_SURPRISED = WELLBEING_CONVERSION_FACTOR_SURPRISED;
    config.WELLBEING_CONVERSION_FACTOR_DISGUSTED = WELLBEING_CONVERSION_FACTOR_DISGUSTED;
    config.ENGAGEMENT_CONVERSION_FACTOR_HAPPINESS = ENGAGEMENT_CONVERSION_FACTOR_HAPPINESS;
    config.ENGAGEMENT_CONVERSION_FACTOR_SAD = ENGAGEMENT_CONVERSION_FACTOR_SAD;
    config.ENGAGEMENT_CONVERSION_FACTOR_SURPRISED = ENGAGEMENT_CONVERSION_FACTOR_SURPRISED;
    config.ENGAGEMENT_CONVERSION_FACTOR_FEAR = ENGAGEMENT_CONVERSION_FACTOR_FEAR;
    config.ENGAGEMENT_CONVERSION_FACTOR_DISGUSTED = ENGAGEMENT_CONVERSION_FACTOR_DISGUSTED;
    config.ENGAGEMENT_CONVERSION_FACTOR_NEUTRAL = ENGAGEMENT_CONVERSION_FACTOR_NEUTRAL;
    config.ENGAGEMENT_CONVERSION_FACTOR_ANGRY = ENGAGEMENT_CONVERSION_FACTOR_ANGRY;
    config.INTEREST_CONVERSION_FACTOR_HAPPINESS = INTEREST_CONVERSION_FACTOR_HAPPINESS;
    config.INTEREST_CONVERSION_FACTOR_SAD = INTEREST_CONVERSION_FACTOR_SAD;
    config.INTEREST_CONVERSION_FACTOR_SURPRISED = INTEREST_CONVERSION_FACTOR_SURPRISED;
    config.INTEREST_CONVERSION_FACTOR_FEAR = INTEREST_CONVERSION_FACTOR_FEAR;
    config.INTEREST_CONVERSION_FACTOR_DISGUSTED = INTEREST_CONVERSION_FACTOR_DISGUSTED;
    config.INTEREST_CONVERSION_FACTOR_NEUTRAL = INTEREST_CONVERSION_FACTOR_NEUTRAL;
    config.INTEREST_CONVERSION_FACTOR_ANGRY = INTEREST_CONVERSION_FACTOR_ANGRY;
    config.ENERGY_CONVERSION_FACTOR_HAPPINESS_V2 = ENERGY_CONVERSION_FACTOR_HAPPINESS_V2;
    config.ENERGY_CONVERSION_FACTOR_NEUTRAL_V2 = ENERGY_CONVERSION_FACTOR_NEUTRAL_V2;
    config.VALENCE_CONVERSION_FACTOR_HAPPINESS_V2 = VALENCE_CONVERSION_FACTOR_HAPPINESS_V2;
    config.YAWN_CERTAINTY_THRESHOLD = YAWN_CERTAINTY_THRESHOLD;
    config.YAWN_TIREDNESS_TIME_THRESHOLD = YAWN_TIREDNESS_TIME_THRESHOLD;
    config.EYE_CLOSED_CERTAINTY_THRESHOLD = EYE_CLOSED_CERTAINTY_THRESHOLD;
    config.EYE_CLOSED_ASLEEP_TIME_THRESHOLD = EYE_CLOSED_ASLEEP_TIME_THRESHOLD;
    config.EYE_BLINKED_CERTAINTY_THRESHOLD = EYE_BLINKED_CERTAINTY_THRESHOLD;
    config.YAW_ANGLE_ALERT_THRESHOLD = YAW_ANGLE_ALERT_THRESHOLD;
    config.PITCH_ANGLE_MIN_ALERT_THRESHOLD = PITCH_ANGLE_MIN_ALERT_THRESHOLD;
    config.PITCH_ANGLE_MAX_ALERT_THRESHOLD = PITCH_ANGLE_MAX_ALERT_THRESHOLD;
    config.YAW_ANGLE_MIN_ALERT_THRESHOLD = YAW_ANGLE_MIN_ALERT_THRESHOLD;
    config.YAW_ANGLE_MAX_ALERT_THRESHOLD = YAW_ANGLE_MAX_ALERT_THRESHOLD;
    config.PITCH_ANGLE_MIN_EMOTION_FILTER_THRESHOLD = PITCH_ANGLE_MIN_EMOTION_FILTER_THRESHOLD;
    config.PITCH_ANGLE_MAX_EMOTION_FILTER_THRESHOLD = PITCH_ANGLE_MAX_EMOTION_FILTER_THRESHOLD;
    config.YAW_ANGLE_MIN_EMOTION_FILTER_THRESHOLD = YAW_ANGLE_MIN_EMOTION_FILTER_THRESHOLD;
    config.YAW_ANGLE_MAX_EMOTION_FILTER_THRESHOLD = YAW_ANGLE_MAX_EMOTION_FILTER_THRESHOLD;
    config.ROLL_ANGLE_MIN_EMOTION_FILTER_THRESHOLD = ROLL_ANGLE_MIN_EMOTION_FILTER_THRESHOLD;
    config.ROLL_ANGLE_MAX_EMOTION_FILTER_THRESHOLD = ROLL_ANGLE_MAX_EMOTION_FILTER_THRESHOLD;
    config.FILTER_BOX_SIZE = FILTER_BOX_SIZE;
    config.HAND_POINTS_ON_FACE_THRESHOLD = HAND_POINTS_ON_FACE_THRESHOLD;

    initialized = true
}

export const useTempConfig = ({
                                  HAPPINESS_MIN_IN,
                                  HAPPINESS_MIN_OUT,
                                  HAPPINESS_MAX_IN,
                                  HAPPINESS_MAX_OUT,
                                  HAPPINESS_CERTAINTY_THRESHOLD,
                                  NEUTRAL_MIN_IN,
                                  NEUTRAL_MIN_OUT,
                                  NEUTRAL_MAX_IN,
                                  NEUTRAL_MAX_OUT,
                                  NEUTRAL_CERTAINTY_THRESHOLD,
                                  EMOTIONAL_MIN_IN,
                                  EMOTIONAL_MIN_OUT,
                                  EMOTIONAL_MAX_IN,
                                  EMOTIONAL_MAX_OUT,
                                  SADNESS_CERTAINTY_THRESHOLD,
                                  ANGRY_CERTAINTY_THRESHOLD,
                                  BASELINE_HAPPINESS_MIN_IN,
                                  BASELINE_HAPPINESS_MIN_OUT,
                                  BASELINE_HAPPINESS_MAX_IN,
                                  BASELINE_HAPPINESS_MAX_OUT,
                                  BASELINE_HAPPINESS_CERTAINTY_THRESHOLD,
                                  BASELINE_NEUTRAL_MIN_IN,
                                  BASELINE_NEUTRAL_MIN_OUT,
                                  BASELINE_NEUTRAL_MAX_IN,
                                  BASELINE_NEUTRAL_MAX_OUT,
                                  BASELINE_NEUTRAL_CERTAINTY_THRESHOLD,
                                  BASELINE_EMOTIONAL_MIN_IN,
                                  BASELINE_EMOTIONAL_MIN_OUT,
                                  BASELINE_EMOTIONAL_MAX_IN,
                                  BASELINE_EMOTIONAL_MAX_OUT,
                                  BASELINE_SADNESS_CERTAINTY_THRESHOLD,
                                  BASELINE_ANGRY_CERTAINTY_THRESHOLD,
                                  DISGUSTED_CERTAINTY_THRESHOLD,
                                  BASELINE_DISGUSTED_CERTAINTY_THRESHOLD,
                                  FEARFUL_CERTAINTY_THRESHOLD,
                                  BASELINE_FEARFUL_CERTAINTY_THRESHOLD,
                                  SURPRISED_CERTAINTY_THRESHOLD,
                                  BASELINE_SURPRISED_CERTAINTY_THRESHOLD,
                                  ENERGY_CONVERSION_FACTOR_NEUTRAL,
                                  ENERGY_CONVERSION_FACTOR_HAPPINESS,
                                  ENERGY_CONVERSION_FACTOR_DISGUSTED,
                                  ENERGY_CONVERSION_FACTOR_SAD,
                                  ENERGY_CONVERSION_FACTOR_ANGRY,
                                  ENERGY_CONVERSION_FACTOR_FEARFUL,
                                  ENERGY_CONVERSION_FACTOR_SURPRISED,
                                  VALENCE_CONVERSION_FACTOR_NEUTRAL,
                                  VALENCE_CONVERSION_FACTOR_HAPPINESS,
                                  VALENCE_CONVERSION_FACTOR_DISGUSTED,
                                  VALENCE_CONVERSION_FACTOR_SAD,
                                  VALENCE_CONVERSION_FACTOR_ANGRY,
                                  VALENCE_CONVERSION_FACTOR_FEARFUL,
                                  VALENCE_CONVERSION_FACTOR_SURPRISED,
                                  BASELINE_ANGRY_MIN_IN,
                                  BASELINE_ANGRY_MAX_IN,
                                  BASELINE_ANGRY_MAX_OUT,
                                  BASELINE_ANGRY_MIN_OUT,
                                  BASELINE_DISGUSTED_MIN_IN,
                                  BASELINE_DISGUSTED_MAX_IN,
                                  BASELINE_DISGUSTED_MAX_OUT,
                                  BASELINE_DISGUSTED_MIN_OUT,
                                  BASELINE_SAD_MIN_IN,
                                  BASELINE_SAD_MIN_OUT,
                                  BASELINE_SAD_MAX_IN,
                                  BASELINE_SAD_MAX_OUT,
                                  BASELINE_FEARFUL_MIN_IN,
                                  BASELINE_FEARFUL_MIN_OUT,
                                  BASELINE_FEARFUL_MAX_IN,
                                  BASELINE_FEARFUL_MAX_OUT,
                                  BASELINE_SURPRISED_MIN_IN,
                                  BASELINE_SURPRISED_MIN_OUT,
                                  BASELINE_SURPRISED_MAX_IN,
                                  BASELINE_SURPRISED_MAX_OUT,
                                  SAD_MIN_IN,
                                  SAD_MIN_OUT,
                                  SAD_MAX_IN,
                                  SAD_MAX_OUT,
                                  ANGRY_MIN_IN,
                                  ANGRY_MIN_OUT,
                                  ANGRY_MAX_IN,
                                  ANGRY_MAX_OUT,
                                  FEARFUL_MIN_IN,
                                  FEARFUL_MIN_OUT,
                                  FEARFUL_MAX_IN,
                                  FEARFUL_MAX_OUT,
                                  DISGUSTED_MIN_IN,
                                  DISGUSTED_MIN_OUT,
                                  DISGUSTED_MAX_IN,
                                  DISGUSTED_MAX_OUT,
                                  SURPRISED_MIN_IN,
                                  SURPRISED_MIN_OUT,
                                  SURPRISED_MAX_IN,
                                  SURPRISED_MAX_OUT,
                                  STRESS_CONVERSION_FACTOR_ANGRY,
                                  STRESS_CONVERSION_FACTOR_FEAR,
                                  STRESS_CONVERSION_FACTOR_NEUTRAL,
                                  STRESS_CONVERSION_FACTOR_HAPPINESS,
                                  STRESS_CONVERSION_FACTOR_SAD,
                                  STRESS_CONVERSION_FACTOR_SURPRISED,
                                  STRESS_CONVERSION_FACTOR_DISGUSTED,
                                  WELLBEING_CONVERSION_FACTOR_HAPPINESS,
                                  WELLBEING_CONVERSION_FACTOR_NEUTRAL,
                                  WELLBEING_CONVERSION_FACTOR_ANGRY,
                                  WELLBEING_CONVERSION_FACTOR_FEAR,
                                  WELLBEING_CONVERSION_FACTOR_SAD,
                                  WELLBEING_CONVERSION_FACTOR_SURPRISED,
                                  WELLBEING_CONVERSION_FACTOR_DISGUSTED,
                                  ENGAGEMENT_CONVERSION_FACTOR_HAPPINESS,
                                  ENGAGEMENT_CONVERSION_FACTOR_SAD,
                                  ENGAGEMENT_CONVERSION_FACTOR_SURPRISED,
                                  ENGAGEMENT_CONVERSION_FACTOR_FEAR,
                                  ENGAGEMENT_CONVERSION_FACTOR_DISGUSTED,
                                  ENGAGEMENT_CONVERSION_FACTOR_NEUTRAL,
                                  ENGAGEMENT_CONVERSION_FACTOR_ANGRY,
                                  INTEREST_CONVERSION_FACTOR_HAPPINESS,
                                  INTEREST_CONVERSION_FACTOR_SAD,
                                  INTEREST_CONVERSION_FACTOR_SURPRISED,
                                  INTEREST_CONVERSION_FACTOR_FEAR,
                                  INTEREST_CONVERSION_FACTOR_DISGUSTED,
                                  INTEREST_CONVERSION_FACTOR_NEUTRAL,
                                  INTEREST_CONVERSION_FACTOR_ANGRY,
                                  ENERGY_CONVERSION_FACTOR_HAPPINESS_V2,
                                  ENERGY_CONVERSION_FACTOR_NEUTRAL_V2,
                                  VALENCE_CONVERSION_FACTOR_HAPPINESS_V2,
                                  YAWN_CERTAINTY_THRESHOLD,
                                  YAWN_TIREDNESS_TIME_THRESHOLD,
                                  EYE_CLOSED_CERTAINTY_THRESHOLD,
                                  EYE_CLOSED_ASLEEP_TIME_THRESHOLD,
                                  EYE_BLINKED_CERTAINTY_THRESHOLD,
                                  YAW_ANGLE_ALERT_THRESHOLD,
                                  PITCH_ANGLE_MIN_ALERT_THRESHOLD,
                                  PITCH_ANGLE_MAX_ALERT_THRESHOLD,
                                  YAW_ANGLE_MIN_ALERT_THRESHOLD,
                                  YAW_ANGLE_MAX_ALERT_THRESHOLD,
                                  PITCH_ANGLE_MIN_EMOTION_FILTER_THRESHOLD,
                                  PITCH_ANGLE_MAX_EMOTION_FILTER_THRESHOLD,
                                  YAW_ANGLE_MIN_EMOTION_FILTER_THRESHOLD,
                                  YAW_ANGLE_MAX_EMOTION_FILTER_THRESHOLD,
                                  ROLL_ANGLE_MIN_EMOTION_FILTER_THRESHOLD,
                                  ROLL_ANGLE_MAX_EMOTION_FILTER_THRESHOLD,
                                  FILTER_BOX_SIZE,
                                  HAND_POINTS_ON_FACE_THRESHOLD
                              }) => {
    tempConfig.HAPPINESS_MIN_IN = HAPPINESS_MIN_IN;
    tempConfig.HAPPINESS_MIN_OUT = HAPPINESS_MIN_OUT;
    tempConfig.HAPPINESS_MAX_IN = HAPPINESS_MAX_IN;
    tempConfig.HAPPINESS_MAX_OUT = HAPPINESS_MAX_OUT;
    tempConfig.HAPPINESS_CERTAINTY_THRESHOLD = HAPPINESS_CERTAINTY_THRESHOLD;
    tempConfig.NEUTRAL_MIN_IN = NEUTRAL_MIN_IN;
    tempConfig.NEUTRAL_MIN_OUT = NEUTRAL_MIN_OUT;
    tempConfig.NEUTRAL_MAX_IN = NEUTRAL_MAX_IN;
    tempConfig.NEUTRAL_MAX_OUT = NEUTRAL_MAX_OUT;
    tempConfig.NEUTRAL_CERTAINTY_THRESHOLD = NEUTRAL_CERTAINTY_THRESHOLD;
    tempConfig.EMOTIONAL_MIN_IN = EMOTIONAL_MIN_IN;
    tempConfig.EMOTIONAL_MIN_OUT = EMOTIONAL_MIN_OUT;
    tempConfig.EMOTIONAL_MAX_IN = EMOTIONAL_MAX_IN;
    tempConfig.EMOTIONAL_MAX_OUT = EMOTIONAL_MAX_OUT;
    tempConfig.SADNESS_CERTAINTY_THRESHOLD = SADNESS_CERTAINTY_THRESHOLD;
    tempConfig.ANGRY_CERTAINTY_THRESHOLD = ANGRY_CERTAINTY_THRESHOLD;
    tempConfig.BASELINE_HAPPINESS_MIN_IN = BASELINE_HAPPINESS_MIN_IN;
    tempConfig.BASELINE_HAPPINESS_MIN_OUT = BASELINE_HAPPINESS_MIN_OUT;
    tempConfig.BASELINE_HAPPINESS_MAX_IN = BASELINE_HAPPINESS_MAX_IN;
    tempConfig.BASELINE_HAPPINESS_MAX_OUT = BASELINE_HAPPINESS_MAX_OUT;
    tempConfig.BASELINE_HAPPINESS_CERTAINTY_THRESHOLD = BASELINE_HAPPINESS_CERTAINTY_THRESHOLD;
    tempConfig.BASELINE_NEUTRAL_MIN_IN = BASELINE_NEUTRAL_MIN_IN;
    tempConfig.BASELINE_NEUTRAL_MIN_OUT = BASELINE_NEUTRAL_MIN_OUT;
    tempConfig.BASELINE_NEUTRAL_MAX_IN = BASELINE_NEUTRAL_MAX_IN;
    tempConfig.BASELINE_NEUTRAL_MAX_OUT = BASELINE_NEUTRAL_MAX_OUT;
    tempConfig.BASELINE_NEUTRAL_CERTAINTY_THRESHOLD = BASELINE_NEUTRAL_CERTAINTY_THRESHOLD;
    tempConfig.BASELINE_EMOTIONAL_MIN_IN = BASELINE_EMOTIONAL_MIN_IN;
    tempConfig.BASELINE_EMOTIONAL_MIN_OUT = BASELINE_EMOTIONAL_MIN_OUT;
    tempConfig.BASELINE_EMOTIONAL_MAX_IN = BASELINE_EMOTIONAL_MAX_IN;
    tempConfig.BASELINE_EMOTIONAL_MAX_OUT = BASELINE_EMOTIONAL_MAX_OUT;
    tempConfig.BASELINE_SADNESS_CERTAINTY_THRESHOLD = BASELINE_SADNESS_CERTAINTY_THRESHOLD;
    tempConfig.BASELINE_ANGRY_CERTAINTY_THRESHOLD = BASELINE_ANGRY_CERTAINTY_THRESHOLD;
    tempConfig.DISGUSTED_CERTAINTY_THRESHOLD = DISGUSTED_CERTAINTY_THRESHOLD;
    tempConfig.BASELINE_DISGUSTED_CERTAINTY_THRESHOLD = BASELINE_DISGUSTED_CERTAINTY_THRESHOLD;
    tempConfig.FEARFUL_CERTAINTY_THRESHOLD = FEARFUL_CERTAINTY_THRESHOLD;
    tempConfig.BASELINE_FEARFUL_CERTAINTY_THRESHOLD = BASELINE_FEARFUL_CERTAINTY_THRESHOLD;
    tempConfig.SURPRISED_CERTAINTY_THRESHOLD = SURPRISED_CERTAINTY_THRESHOLD;
    tempConfig.BASELINE_SURPRISED_CERTAINTY_THRESHOLD = BASELINE_SURPRISED_CERTAINTY_THRESHOLD;
    tempConfig.ENERGY_CONVERSION_FACTOR_NEUTRAL = ENERGY_CONVERSION_FACTOR_NEUTRAL;
    tempConfig.ENERGY_CONVERSION_FACTOR_HAPPINESS = ENERGY_CONVERSION_FACTOR_HAPPINESS;
    tempConfig.ENERGY_CONVERSION_FACTOR_DISGUSTED = ENERGY_CONVERSION_FACTOR_DISGUSTED;
    tempConfig.ENERGY_CONVERSION_FACTOR_SAD = ENERGY_CONVERSION_FACTOR_SAD;
    tempConfig.ENERGY_CONVERSION_FACTOR_ANGRY = ENERGY_CONVERSION_FACTOR_ANGRY;
    tempConfig.ENERGY_CONVERSION_FACTOR_FEARFUL = ENERGY_CONVERSION_FACTOR_FEARFUL;
    tempConfig.ENERGY_CONVERSION_FACTOR_SURPRISED = ENERGY_CONVERSION_FACTOR_SURPRISED;
    tempConfig.VALENCE_CONVERSION_FACTOR_NEUTRAL = VALENCE_CONVERSION_FACTOR_NEUTRAL;
    tempConfig.VALENCE_CONVERSION_FACTOR_HAPPINESS = VALENCE_CONVERSION_FACTOR_HAPPINESS;
    tempConfig.VALENCE_CONVERSION_FACTOR_DISGUSTED = VALENCE_CONVERSION_FACTOR_DISGUSTED;
    tempConfig.VALENCE_CONVERSION_FACTOR_SAD = VALENCE_CONVERSION_FACTOR_SAD;
    tempConfig.VALENCE_CONVERSION_FACTOR_ANGRY = VALENCE_CONVERSION_FACTOR_ANGRY;
    tempConfig.VALENCE_CONVERSION_FACTOR_FEARFUL = VALENCE_CONVERSION_FACTOR_FEARFUL;
    tempConfig.VALENCE_CONVERSION_FACTOR_SURPRISED = VALENCE_CONVERSION_FACTOR_SURPRISED;
    tempConfig.BASELINE_ANGRY_MIN_IN = BASELINE_ANGRY_MIN_IN;
    tempConfig.BASELINE_ANGRY_MAX_IN = BASELINE_ANGRY_MAX_IN;
    tempConfig.BASELINE_ANGRY_MAX_OUT = BASELINE_ANGRY_MAX_OUT;
    tempConfig.BASELINE_ANGRY_MIN_OUT = BASELINE_ANGRY_MIN_OUT;
    tempConfig.BASELINE_DISGUSTED_MIN_IN = BASELINE_DISGUSTED_MIN_IN;
    tempConfig.BASELINE_DISGUSTED_MAX_IN = BASELINE_DISGUSTED_MAX_IN;
    tempConfig.BASELINE_DISGUSTED_MAX_OUT = BASELINE_DISGUSTED_MAX_OUT;
    tempConfig.BASELINE_DISGUSTED_MIN_OUT = BASELINE_DISGUSTED_MIN_OUT;
    tempConfig.BASELINE_SAD_MIN_IN = BASELINE_SAD_MIN_IN;
    tempConfig.BASELINE_SAD_MIN_OUT = BASELINE_SAD_MIN_OUT;
    tempConfig.BASELINE_SAD_MAX_IN = BASELINE_SAD_MAX_IN;
    tempConfig.BASELINE_SAD_MAX_OUT = BASELINE_SAD_MAX_OUT;
    tempConfig.BASELINE_FEARFUL_MIN_IN = BASELINE_FEARFUL_MIN_IN;
    tempConfig.BASELINE_FEARFUL_MIN_OUT = BASELINE_FEARFUL_MIN_OUT;
    tempConfig.BASELINE_FEARFUL_MAX_IN = BASELINE_FEARFUL_MAX_IN;
    tempConfig.BASELINE_FEARFUL_MAX_OUT = BASELINE_FEARFUL_MAX_OUT;
    tempConfig.BASELINE_SURPRISED_MIN_IN = BASELINE_SURPRISED_MIN_IN;
    tempConfig.BASELINE_SURPRISED_MIN_OUT = BASELINE_SURPRISED_MIN_OUT;
    tempConfig.BASELINE_SURPRISED_MAX_IN = BASELINE_SURPRISED_MAX_IN;
    tempConfig.BASELINE_SURPRISED_MAX_OUT = BASELINE_SURPRISED_MAX_OUT;
    tempConfig.SAD_MIN_IN = SAD_MIN_IN;
    tempConfig.SAD_MIN_OUT = SAD_MIN_OUT;
    tempConfig.SAD_MAX_IN = SAD_MAX_IN;
    tempConfig.SAD_MAX_OUT = SAD_MAX_OUT;
    tempConfig.ANGRY_MIN_IN = ANGRY_MIN_IN;
    tempConfig.ANGRY_MIN_OUT = ANGRY_MIN_OUT;
    tempConfig.ANGRY_MAX_IN = ANGRY_MAX_IN;
    tempConfig.ANGRY_MAX_OUT = ANGRY_MAX_OUT;
    tempConfig.FEARFUL_MIN_IN = FEARFUL_MIN_IN;
    tempConfig.FEARFUL_MIN_OUT = FEARFUL_MIN_OUT;
    tempConfig.FEARFUL_MAX_IN = FEARFUL_MAX_IN;
    tempConfig.FEARFUL_MAX_OUT = FEARFUL_MAX_OUT;
    tempConfig.DISGUSTED_MIN_IN = DISGUSTED_MIN_IN;
    tempConfig.DISGUSTED_MIN_OUT = DISGUSTED_MIN_OUT;
    tempConfig.DISGUSTED_MAX_IN = DISGUSTED_MAX_IN;
    tempConfig.DISGUSTED_MAX_OUT = DISGUSTED_MAX_OUT;
    tempConfig.SURPRISED_MIN_IN = SURPRISED_MIN_IN;
    tempConfig.SURPRISED_MIN_OUT = SURPRISED_MIN_OUT;
    tempConfig.SURPRISED_MAX_IN = SURPRISED_MAX_IN;
    tempConfig.SURPRISED_MAX_OUT = SURPRISED_MAX_OUT;
    tempConfig.STRESS_CONVERSION_FACTOR_ANGRY = STRESS_CONVERSION_FACTOR_ANGRY;
    tempConfig.STRESS_CONVERSION_FACTOR_FEAR = STRESS_CONVERSION_FACTOR_FEAR;
    tempConfig.STRESS_CONVERSION_FACTOR_NEUTRAL = STRESS_CONVERSION_FACTOR_NEUTRAL;
    tempConfig.STRESS_CONVERSION_FACTOR_HAPPINESS = STRESS_CONVERSION_FACTOR_HAPPINESS;
    tempConfig.STRESS_CONVERSION_FACTOR_SAD = STRESS_CONVERSION_FACTOR_SAD;
    tempConfig.STRESS_CONVERSION_FACTOR_SURPRISED = STRESS_CONVERSION_FACTOR_SURPRISED;
    tempConfig.STRESS_CONVERSION_FACTOR_DISGUSTED = STRESS_CONVERSION_FACTOR_DISGUSTED;
    tempConfig.WELLBEING_CONVERSION_FACTOR_HAPPINESS = WELLBEING_CONVERSION_FACTOR_HAPPINESS;
    tempConfig.WELLBEING_CONVERSION_FACTOR_NEUTRAL = WELLBEING_CONVERSION_FACTOR_NEUTRAL;
    tempConfig.WELLBEING_CONVERSION_FACTOR_ANGRY = WELLBEING_CONVERSION_FACTOR_ANGRY;
    tempConfig.WELLBEING_CONVERSION_FACTOR_FEAR = WELLBEING_CONVERSION_FACTOR_FEAR;
    tempConfig.WELLBEING_CONVERSION_FACTOR_SAD = WELLBEING_CONVERSION_FACTOR_SAD;
    tempConfig.WELLBEING_CONVERSION_FACTOR_SURPRISED = WELLBEING_CONVERSION_FACTOR_SURPRISED;
    tempConfig.WELLBEING_CONVERSION_FACTOR_DISGUSTED = WELLBEING_CONVERSION_FACTOR_DISGUSTED;
    tempConfig.ENGAGEMENT_CONVERSION_FACTOR_HAPPINESS = ENGAGEMENT_CONVERSION_FACTOR_HAPPINESS;
    tempConfig.ENGAGEMENT_CONVERSION_FACTOR_SAD = ENGAGEMENT_CONVERSION_FACTOR_SAD;
    tempConfig.ENGAGEMENT_CONVERSION_FACTOR_SURPRISED = ENGAGEMENT_CONVERSION_FACTOR_SURPRISED;
    tempConfig.ENGAGEMENT_CONVERSION_FACTOR_FEAR = ENGAGEMENT_CONVERSION_FACTOR_FEAR;
    tempConfig.ENGAGEMENT_CONVERSION_FACTOR_DISGUSTED = ENGAGEMENT_CONVERSION_FACTOR_DISGUSTED;
    tempConfig.ENGAGEMENT_CONVERSION_FACTOR_NEUTRAL = ENGAGEMENT_CONVERSION_FACTOR_NEUTRAL;
    tempConfig.ENGAGEMENT_CONVERSION_FACTOR_ANGRY = ENGAGEMENT_CONVERSION_FACTOR_ANGRY;
    tempConfig.INTEREST_CONVERSION_FACTOR_HAPPINESS = INTEREST_CONVERSION_FACTOR_HAPPINESS;
    tempConfig.INTEREST_CONVERSION_FACTOR_SAD = INTEREST_CONVERSION_FACTOR_SAD;
    tempConfig.INTEREST_CONVERSION_FACTOR_SURPRISED = INTEREST_CONVERSION_FACTOR_SURPRISED;
    tempConfig.INTEREST_CONVERSION_FACTOR_FEAR = INTEREST_CONVERSION_FACTOR_FEAR;
    tempConfig.INTEREST_CONVERSION_FACTOR_DISGUSTED = INTEREST_CONVERSION_FACTOR_DISGUSTED;
    tempConfig.INTEREST_CONVERSION_FACTOR_NEUTRAL = INTEREST_CONVERSION_FACTOR_NEUTRAL;
    tempConfig.INTEREST_CONVERSION_FACTOR_ANGRY = INTEREST_CONVERSION_FACTOR_ANGRY;
    tempConfig.ENERGY_CONVERSION_FACTOR_HAPPINESS_V2 = ENERGY_CONVERSION_FACTOR_HAPPINESS_V2;
    tempConfig.ENERGY_CONVERSION_FACTOR_NEUTRAL_V2 = ENERGY_CONVERSION_FACTOR_NEUTRAL_V2;
    tempConfig.VALENCE_CONVERSION_FACTOR_HAPPINESS_V2 = VALENCE_CONVERSION_FACTOR_HAPPINESS_V2;

    tempConfig.YAWN_CERTAINTY_THRESHOLD = YAWN_CERTAINTY_THRESHOLD;
    tempConfig.YAWN_TIREDNESS_TIME_THRESHOLD = YAWN_TIREDNESS_TIME_THRESHOLD;
    tempConfig.EYE_CLOSED_CERTAINTY_THRESHOLD = EYE_CLOSED_CERTAINTY_THRESHOLD;
    tempConfig.EYE_CLOSED_ASLEEP_TIME_THRESHOLD = EYE_CLOSED_ASLEEP_TIME_THRESHOLD;
    tempConfig.EYE_BLINKED_CERTAINTY_THRESHOLD = EYE_BLINKED_CERTAINTY_THRESHOLD;
    tempConfig.YAW_ANGLE_ALERT_THRESHOLD = YAW_ANGLE_ALERT_THRESHOLD;
    tempConfig.PITCH_ANGLE_MIN_ALERT_THRESHOLD = PITCH_ANGLE_MIN_ALERT_THRESHOLD;
    tempConfig.PITCH_ANGLE_MAX_ALERT_THRESHOLD = PITCH_ANGLE_MAX_ALERT_THRESHOLD;
    tempConfig.YAW_ANGLE_MIN_ALERT_THRESHOLD = YAW_ANGLE_MIN_ALERT_THRESHOLD;
    tempConfig.YAW_ANGLE_MAX_ALERT_THRESHOLD = YAW_ANGLE_MAX_ALERT_THRESHOLD;
    tempConfig.PITCH_ANGLE_MIN_EMOTION_FILTER_THRESHOLD = PITCH_ANGLE_MIN_EMOTION_FILTER_THRESHOLD;
    tempConfig.PITCH_ANGLE_MAX_EMOTION_FILTER_THRESHOLD = PITCH_ANGLE_MAX_EMOTION_FILTER_THRESHOLD;
    tempConfig.YAW_ANGLE_MIN_EMOTION_FILTER_THRESHOLD = YAW_ANGLE_MIN_EMOTION_FILTER_THRESHOLD;
    tempConfig.YAW_ANGLE_MAX_EMOTION_FILTER_THRESHOLD = YAW_ANGLE_MAX_EMOTION_FILTER_THRESHOLD;
    tempConfig.ROLL_ANGLE_MIN_EMOTION_FILTER_THRESHOLD = ROLL_ANGLE_MIN_EMOTION_FILTER_THRESHOLD;
    tempConfig.ROLL_ANGLE_MAX_EMOTION_FILTER_THRESHOLD = ROLL_ANGLE_MAX_EMOTION_FILTER_THRESHOLD;
    tempConfig.FILTER_BOX_SIZE = FILTER_BOX_SIZE;
    tempConfig.HAND_POINTS_ON_FACE_THRESHOLD = HAND_POINTS_ON_FACE_THRESHOLD;

    useTemp = true
}

export const restoreConfigToCurrent = () => {
    useTemp = false
}
